import { ChildProps } from '@apollo/client/react/hoc';
import { withUserContext, IUserContext } from '@reverbdotcom/commons';
import { gql } from '@reverbdotcom/commons/src/gql';
import CMSListingsCollection from '@reverbdotcom/commons/src/cms/components/cms_listings_collection';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { JustListedForYouQuery, reverb_search_ListingsSearchRequest_Sort } from '@reverbdotcom/commons/src/gql/graphql';
import { Paths } from '@reverbdotcom/commons/src/url_helpers';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import I18n from 'i18n-js';
import React from 'react';

export interface IProps {
  handleCreateWatchResult?: () => void;
  ssr?: boolean;
  indentedMosaic?: boolean;
  maxCount?: number;
}

type Props = ChildProps<IProps & IUserContext, JustListedForYouQuery.Query>;

const DEFAULT_MAX_COUNT = 8;

export function JustListedForYou(props: Props) {
  const { data, user } = props;

  const topProductTypeUuids = data?.me?.profile?.topProductTypeUuids || [];
  const topProductTypes = data?.me?.profile?.topProductTypes || [];
  const eligible = !data?.loading && (user.loggedOut || topProductTypeUuids.length > 0);

  useViewTracking({
    eventName: MParticleEventName.ComponentView,
    componentName: 'JustListedForYouRow',
  }, eligible);

  if (!eligible) {
    return null;
  }

  const topProductAffinity = topProductTypeUuids[0];
  const categoryNames = topProductTypeUuids.map((uuid) => I18n.t(`discovery.taxonomy.${uuid}`));
  const title = categoryNames[0] ? I18n.t('discovery.homepage.justListedForYou', { categoryName: categoryNames[0] }) : I18n.t('discovery.homepage.justListed');
  return (
    <CMSListingsCollection
      ctaTargetHref={Paths.marketplace.expand({ sort: 'published_at|desc', product_type: topProductTypes[0] })}
      categoryUuids={topProductAffinity ? [topProductAffinity] : []}
      sort={reverb_search_ListingsSearchRequest_Sort.PUBLISHED_AT_DESC}
      title={title}
      trackingName="HomepageJustListedForYou"
      userShippingRegion={user.shippingRegionCode}
      maxCount={props.maxCount || DEFAULT_MAX_COUNT}
      largeTiles={false}
      ssr={false}
      handleCreateWatchResult={props.handleCreateWatchResult}
      indentedMosaic={props.indentedMosaic}
    />
  );
}

const withQuery = withGraphql<Props, JustListedForYouQuery.Query>(
  gql(`
  query Just_Listed_For_You_Query{
    me {
      uuid
      profile {
        topProductTypeUuids
        topProductTypes
      }
    }
  }`),
  {
    skip: (props) => props.user?.loggedOut,
    options: (props) => {
      return {
        ssr: props.ssr,
        variables: {},
      };
    },
  },
);

export const JustListedForYouRow = withUserContext(withQuery(JustListedForYou));
